import React, { useState, useEffect } from "react";
import SideBar from "./SideBar"; // Classic (Default)
import ModernSidebar from "./ModernSidebar"; // Modern

const SideBarWrapper = (props) => {
  // ✅ استعادة التصميم المحفوظ من localStorage (الديفولت = classic)
  const [isModern, setIsModern] = useState(() => {
    const saved = localStorage.getItem("sidebarStyle");
    return saved === "modern"; // إذا مش موجود، يرجع false (classic)
  });

  // ✅ حفظ التصميم عند التغيير
  useEffect(() => {
    localStorage.setItem("sidebarStyle", isModern ? "modern" : "classic");
  }, [isModern]);

  // ✅ إضافة دالة التبديل في props
  const extendedProps = {
    ...props,
    toggleSidebarStyle: () => setIsModern((prev) => !prev),
    isModernStyle: isModern,
  };

  // ✅ عرض التصميم المناسب
  return isModern ? (
    <ModernSidebar {...extendedProps} />
  ) : (
    <SideBar {...extendedProps} />
  );
};

export default SideBarWrapper;